import { Vector3 } from 'three';

export class ArticlePositionLayerData {
  public dimensions?: ArticlePositionLayerDimensions;
  public viewInfo: ArticlePositionLayerViewInfo = {leftPosition: null, rightPosition: null};
}

export type ArticlePositionLayerViewInfo = {
  leftPosition: Vector3 | null;
  rightPosition: Vector3 | null;
  isValid?: boolean;
}

export type ArticlePositionLayerDimensions = {
  distanceFromTopToRailCenter: number;
  distanceFromBottomToRailCenter: number;
  railCenterPositionZ: number;
}
